import {  useContext } from "react";
import { PageContext } from "./PageContext";

export const usePage = () => {
  const context = useContext(PageContext);

  if (context === undefined) {
    throw new Error("usePage must be used within an PageProvider");
  }

  return context;
};
